import { render } from "./BaseMultiSelect.vue?vue&type=template&id=b5d8ab30&scoped=true"
import script from "./BaseMultiSelect.vue?vue&type=script&lang=js"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./BaseMultiSelect.vue?vue&type=style&index=1&id=b5d8ab30&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d8ab30"]])

export default __exports__